<template>
	<v-slide-item>
		<v-menu	close-delay
				offset-y>
			<template v-slot:activator="{ on }">
				<v-btn class="customVBtn menu_" v-on="on">
					<v-row no-gutters align="end">
						<v-col class="center" cols="auto">
							<v-icon>preview</v-icon>
						</v-col>
						<v-col class="ml-2 center">
							<span class="button_">PREVIEW</span>
						</v-col>
					</v-row>
				</v-btn>
			</template>
			<v-list max-height="85vh">
				<template v-for="(previewVals, previewKey) in previews_">
					<v-btn	:key="previewKey"
					
							class="customVBtn preview_"
							color="success"
							large
							text
							tile
							:to="{ name: 'page', params: { pageName: 'dummy', pageType: previewKey }}">
						<v-row dense align="center">
							<v-col class="center" cols="auto">
								<v-icon v-text="previewVals.icon" />
							</v-col>
							<v-col class="center" cols="auto">
								<span	class="overline" 
										v-text="previewVals.title" />
							</v-col>
						</v-row>
					</v-btn>
				</template>
			</v-list>
		</v-menu>
	</v-slide-item>
</template>

<script>
	export default {
		name: 'BuilderPreviewSlideItem',
		data() {
			return {
				previews_: {
					alert: {
						icon: 'list',
						title: 'Alert'
					},
					banner: {
						icon: 'list',
						title: 'Banner'
					},
					calendar: {
						icon: 'today',
						title: 'Calendar'
					},
					card: {
						icon: 'view_module',
						title: 'Card'
					},
					carousel: {
						icon: 'view_carousel',
						title: 'Carousel'
					},
					csvStepper: {
						icon: 'view_array',
						title: 'Csv Stepper'
					},
					dataTable: {
						icon: 'table_chart',
						title: 'Data Table'
					},
					expansionPanel: {
						icon: 'view_day',
						title: 'Expansion Panel'
					},
					iframe: {
						icon: 'web',
						title: 'Iframe'
					},
					input: {
						icon: 'view_list',
						title: 'Input'
					},
					inputWithStepper: {
						icon: 'view_list',
						title: 'Input With Stepper'
					},
					sheet: {
						icon: 'view_agenda',
						title: 'Sheet'
					},
					slideGroup: {
						icon: 'view_column',
						title: 'Slide Group'
					},
					stepper: {
						icon: 'double_arrow',
						title: 'Stepper'
					},
					tab: {
						icon: 'vertical_split',
						title: 'Tab'
					},
					treeview: {
						icon: 'account_tree',
						title: 'Tree View'
					},
					window: {
						icon: 'view_array',
						title: 'Window'
					}
				}
			}
		}
	}
</script>

<style scoped>
	.button_ {
		font-size: xx-small !important;
	}
	.preview_ {
		width: 100%;
		text-align: left;
	}
	.v-menu__content {
		max-width: 15% !important;
	}
	.v-menu__content.theme--dark {
		background: #1E1E1E !important;
	}
	.v-menu__content.theme--light {
		background: #FFFFFF !important;
	}
</style>
